import { render } from "./ConceptDetailsForm.vue?vue&type=template&id=64b18d97&scoped=true"
import script from "./ConceptDetailsForm.vue?vue&type=script&lang=js"
export * from "./ConceptDetailsForm.vue?vue&type=script&lang=js"

import "./ConceptDetailsForm.vue?vue&type=style&index=0&id=64b18d97&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b18d97"]])

export default __exports__